import React from "react";
import PropTypes from "prop-types";

import styles from "./block-placeholder.module.scss";

const BlockPlaceholder = ({ className, ...props }) => {
  return (
    <div
      className={`${styles["audience-portarait-placeholder"]} ${className}`}
      {...props}
    >
      Coming soon...
    </div>
  );
};

BlockPlaceholder.propTypes = {
  className: PropTypes.string
};

BlockPlaceholder.defaultProps = {
  className: ""
};

export default BlockPlaceholder;
